/* 把商品名称里的 {color} 换成当前颜色。卡片点色圈、详情页切颜色时本地更新。 */
class ProductSubtitle extends HTMLElement {
  connectedCallback() {
    this.renderColor(this.dataset.color || '');
    this.abortController = new AbortController();
    const signal = this.abortController.signal;
    const card = this.closest('.product-index');

    if (card) {
      card.addEventListener('click', (event) => {
        const swatch = event.target.closest('.js-collection-swatch');
        if (!swatch || !card.contains(swatch)) return;
        const color = swatch.getAttribute('data-option-title') || '';
        if (color) this.renderColor(color);
      }, { signal });
    }

    const position = this.dataset.optionPosition;
    if (!position) return;
    const root = this.closest('.shopify-section') || document;
    root.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.classList || !input.classList.contains('swatches__form--input')) return;
      if (String(input.dataset.position) !== String(position)) return;
      this.renderColor(input.value);
    }, { signal });
  }

  disconnectedCallback() {
    this.abortController?.abort();
  }

  renderColor(color) {
    this.textContent = (this.dataset.template || '')
      .split('{color}')
      .join(String(color || '').trim())
      .replace(/\s+/g, ' ')
      .trim();
  }
}

if (!customElements.get('product-subtitle')) {
  customElements.define('product-subtitle', ProductSubtitle);
}
